import { Helper } from '../helpers/Helper';

export class UserMgr {
  appUser = null;
  jwtToken = null;
  guestUser = false;
  previousUserName = null;

  constructor() {
    this.cacheAppUser();
  }

  setAppUser(appUser) {
    //console.log('setAppUser');
    this.appUser = appUser;
    if (appUser) {
      const appContext = {
        appUser: appUser
      };
      //console.log('appUser:', appContext);
      const thisObj = this;
      return new Promise((resolve, reject) => {
        localStorage.setItem('appContext', JSON.stringify(appContext));
      });
    } else {
      const thisObj = this;
      //console.log('remove appUSer from async storage');
      return new Promise((resolve, reject) => {
        localStorage.removeItem('appContext');
      });
    }
  }

  getAppUser() {
    return this.appUser;
  }

  isProductSU() {
    if (this.appUser) {
      for (let i = 0; i < this.appUser.orgs.length; i++) {
        const org = this.appUser.orgs[i];
        if (org.orgId === 'PRODUCT') {
          if (org.role === 'SUPERUSER') return true; // for backward compatibility
          if (Helper.inArray(org.roles, 'SUPERUSER')) return true;
        }
      }
    }
    return false;
  }

  isProductStaff() {
    if (this.appUser) {
      for (let i = 0; i < this.appUser.orgs.length; i++) {
        const org = this.appUser.orgs[i];
        if (org.orgId === 'PRODUCT') {
          if (org.role === 'STAFF') return true; // for backward compatibility
          if (Helper.inArray(org.roles, 'STAFF')) return true;
        }
      }
    }
    return false;
  }

  getPurpose() {
    //console.log('getPurpose: appUser', this.appUser)
    if (this.appUser && this.appUser.purposeOne) {
      return this.appUser.purposeOne
    }
    return null;
  }

  _clearCache() {
    this.appUser = null;
    this.jwtToken = null;
    this.guestUser = false;
    this.previousUserName = null;
  }

  cacheAppUser() {
    //console.log('cacheAppUser');
    const thisObj = this;
    return new Promise((resolve, reject) => {
      localStorage.getItem('appContext');
    });
  }

  getUserId() {
    if (this.appUser) {
      return this.appUser.id;
    } else {
      return null;
    }
  }

  getOrgId() {
    if (this.isProductSU()) {
      return 'PRODUCT';
    }
    if (this.appUser) {
      for (let i = 0; i < this.appUser.orgs.length; i++) {
        const org = this.appUser.orgs[i];
        if (org.orgId !== 'PRODUCT') {
          if (org.role === 'SUPERUSER' || Helper.inArray(org.roles, 'SUPERUSER')) return org.orgId;
        }
      }
    }
    return null;
  }

  setUserToken(jwtToken) {
    this.jwtToken = jwtToken;
  }

  getUserToken() {
    //console.log('getUserToken:', this.jwtToken ? true : false);
    return this.jwtToken;
  }

  updateUserSettings(settings) {}

  setGuestUser(state) {
    //console.log('setGuestUser');
    this.guestUser = state;
  }

  getGuestUser() {
    //console.log('getGuestUser');
    return this.guestUser;
  }

  setCurrentLoggedInUserName(userName) {
    //console.log('setLastLoggedInUserMobileNumber');
    return new Promise((resolve, reject) => {
      localStorage.setItem('__previousUserName', userName);
    });
  }

  cacheLastLoggedInUserName() {
    return new Promise((resolve, reject) => {
      localStorage.getItem('__previousUserName');
    });
  }

  getLastLoggedInUserName() {
    //console.log('getLastLoggedInUserName');
    return this.previousUserName;
  }
}



// WEBPACK FOOTER //
// ./src/common/mgrs/UserMgr.js